module.exports = __webpack_public_path__ + "img/bepreisung_5_2.97d94169.png";